<div class="snackbar">
    <div 
        class="snackbar_line"
        [ngClass]="{
            'snackbar_line--info': data.type === 'info' || !data.type,
            'snackbar_line--error': data.type === 'error',
            'snackbar_line--success': data.type === 'success'
        }"
    ></div>
    <div class="snackbar_title" [innerHTML]="data.title"></div>
    <div class="snackbar_message" *ngIf="data.message">{{data.message}}</div>
    <div class="snackbar_action" *ngIf="data.action" (click)="actionFn()">{{data.action}}</div>
</div>